import { Component } from "react";
import Header from "../components/header";
import Footer from "../components/footer";

import {
  IoCubeOutline,
  IoCashOutline,
  IoHeadsetOutline,
  IoShieldCheckmarkOutline,
} from "react-icons/io5";

import "../styles/products_shipping_screen.css";

class ProductsShippingScreen extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const { isLoggedIn } = this.props;
    return (
      <>
        <Header isLoggedIn={isLoggedIn} />

        {/* 1. HERO BANNER */}
        <section className="shipping-hero py-5">
          <div className="container">
            <h1 className="mb-0 text-white fw-medium">SHIPPING</h1>
          </div>
        </section>

        {/* 2. SHIPPING IMAGE (Dimensions locked in CSS) */}
        <section className="bg-white">
          <div className="container py-5">
            <img
              src="/assets/misc/package-handling-shipping.jpg"
              alt="Person handing over a cardboard shipping box"
              className="shipping-image shadow-sm rounded-3"
            />
          </div>
        </section>

        {/* 3. SHIPPING CONTENT */}
        <section className="bg-white pb-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-8">
                <div className="info-block mb-5">
                  <h2 className="mb-3">Standard Shipping</h2>
                  <ul className="shipping-list">
                    <li>Free delivery on orders of ₹1,000 or more</li>
                    <li>₹300 delivery fee for orders below ₹1,000</li>
                    <li>Membership fee: ₹1,245</li>
                  </ul>
                </div>

                <div className="info-block mb-5">
                  <h2 className="mb-3">Express Shipping</h2>
                  <ul className="shipping-list mb-2">
                    <li>Free delivery on orders of ₹6,225 or more</li>
                    <li>₹664 delivery fee for orders below ₹6,225</li>
                  </ul>
                  <p className="text-muted small">
                    Please note, expedited and express shipping may not be
                    available for every order.
                  </p>
                </div>

                <hr className="my-5" style={{ borderColor: "#eaeaea" }} />

                <div className="info-block mb-5">
                  <h2 className="mb-3">Shipping Methods</h2>
                  <p className="shipping-text">
                    We offer multiple shipping methods to suit your needs,
                    ensuring your orders reach you quickly and reliably. For
                    domestic shipments, you can choose between standard,
                    expedited, and overnight delivery options, depending on how
                    soon you need your items. International customers can select
                    from a range of shipping services, including economy and
                    priority options, designed to balance speed and
                    cost-effectiveness. We partner with trusted courier services
                    to provide reliable tracking and seamless delivery, no
                    matter where you're located. Additionally, we offer in-store
                    pickup at select locations for those who prefer to collect
                    their orders in person. Whether it's a small package or a
                    bulk shipment, we ensure your products are handled with care
                    and delivered on time.
                  </p>
                </div>

                <div className="info-block mb-5">
                  <h2 className="mb-3">Estimated Delivery Dates</h2>
                  <p className="shipping-text">
                    Our estimated delivery dates give you a clear picture of
                    when you can expect your order to arrive. These estimates
                    depend on the selected shipping method and your location.
                    For standard shipping, domestic deliveries typically take
                    3-7 business days, while expedited options can deliver your
                    items within 1-3 business days. International orders may
                    take longer, ranging from 7-21 business days depending on
                    the destination and customs clearance times. Once your order
                    is shipped, we'll provide you with a tracking number so you
                    can monitor its progress in real-time. Please note that
                    holidays, natural disasters, or unforeseen delays may affect
                    delivery times, but we always strive to keep you informed
                    every step of the way.
                  </p>
                </div>

                <hr className="my-5" style={{ borderColor: "#eaeaea" }} />

                {/* 4. STORE FEATURES GRID */}
                <div className="store-features pt-4 pb-5">
                  <div className="row g-5">
                    {/* Feature 1 */}
                    <div className="col-12 col-md-6">
                      <div className="feature-item">
                        <div className="icon-wrapper-feature">
                          <IoCubeOutline size={28} color="#111111" />
                        </div>
                        <h3 className="feature-title">Ship It Free</h3>
                        <p className="feature-text">
                          Free delivery on all qualifying orders, straight to
                          your door.
                        </p>
                      </div>
                    </div>

                    {/* Feature 2 */}
                    <div className="col-12 col-md-6">
                      <div className="feature-item">
                        <div className="icon-wrapper-feature">
                          <IoCashOutline size={28} color="#111111" />
                        </div>
                        <h3 className="feature-title">Money-Back Guarantee</h3>
                        <p className="feature-text">
                          Return your item for a full refund if it doesn't meet
                          your expectations.
                        </p>
                      </div>
                    </div>

                    {/* Feature 3 */}
                    <div className="col-12 col-md-6">
                      <div className="feature-item">
                        <div className="icon-wrapper-feature">
                          <IoHeadsetOutline size={28} color="#111111" />
                        </div>
                        <h3 className="feature-title">24/7 Customer Support</h3>
                        <p className="feature-text">
                          Our team is available 24/7 to address your inquiries.
                        </p>
                      </div>
                    </div>

                    {/* Feature 4 */}
                    <div className="col-12 col-md-6">
                      <div className="feature-item">
                        <div className="icon-wrapper-feature">
                          <IoShieldCheckmarkOutline size={28} color="#111111" />
                        </div>
                        <h3 className="feature-title">Safe Checkout</h3>
                        <p className="feature-text">
                          Your payment details are always protected with
                          advanced security.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </>
    );
  }
}

export default ProductsShippingScreen;
